
import Vue from "vue";
import {StatisticsService} from "@/services/statistics-service";
import {ISelectItem} from "winfakt-vue-components/src/classes";
import {ApexOptions} from "apexcharts";

export enum Mode {
	WEEK = 0,
	MONTH = 1,
	HALF_YEAR = 2,
	YEAR = 3
}

export default Vue.extend({
	data() {
		return {
			initialSeries: [] as any[],
			mode: Mode.WEEK,
			result: [] as number[]
		};
	},
	computed: {
		modeSelectItems(): ISelectItem<Mode>[] {
			return [
				{
					text: "Week",
					value: Mode.WEEK
				},
				{
					text: "Maand",
					value: Mode.MONTH
				},
				{
					text: "Half jaar",
					value: Mode.HALF_YEAR
				},
				{
					text: "Jaar",
					value: Mode.YEAR
				}
			]as ISelectItem<Mode>[];
		},
		chartOptions(): ApexOptions {
			let ref = this;
			return {
				chart: {},
				xaxis: {
					labels: {
						show: true,
						formatter(value: string): string {
							let date = new Date();
							if (ref.mode == Mode.WEEK || ref.mode == Mode.MONTH) {
								date.setDate(date.getDate() - (ref.result.length - parseInt(value)));
								return `${date.getDate()}/${date.getMonth()+1}`;
							}
							date.setMonth((date.getMonth()) - (ref.result.length - parseInt(value)));
							return `${date.getMonth()+1}/${date.getFullYear()}`;
						}
					},
					title: {
						text: "Dagen"
					}
				},
				yaxis: {
					title: {
						text: "Aantal"
					},
					min: 0,
					forceNiceScale: true
				},
				dataLabels: {
					enabled: false
				}
			};
		}
	},
	methods: {
		async fetch() {
			if (this.mode == Mode.WEEK) {
				this.result = await StatisticsService.getNewDemosLastWeek();
			} else if (this.mode == Mode.MONTH) {
				this.result = await StatisticsService.getNewDemosLastMonth();
			} else if (this.mode == Mode.HALF_YEAR) {
				this.result = await StatisticsService.getNewDemosLastHalfYear();
			} else if (this.mode == Mode.YEAR) {
				this.result = await StatisticsService.getNewDemosLastYear();
			}
			this.updateData();
		},
		updateData() {
			if (!this.$refs.chart) {
				return;
			}
			(this.$refs.chart as any).updateSeries(this.getSeries());
		},
		getSeries() {
			return [{
				name: "Demo registratie",
				data: this.result
			}];
		},
		setMode(mode: Mode) {
			this.mode = mode;
			this.fetch();
		}
	},
	created() {
		this.fetch();
	}
});
